import React, { useState } from 'react';
import { ReactComponent as ArrowDownIcon } from '../../assets/arrow-down.svg';

const PersonalInfoPage = ({ userData, updateUserData, onNext, currentStep, totalSteps }) => {
    const [isGenderOpen, setIsGenderOpen] = useState(false);
    const [isGoalOpen, setIsGoalOpen] = useState(false);

    const genderOptions = ["Мужской", "Женский"];
    const goalOptions = [
        "Студент",
        "Фрилансер",
        "Продаю свои услуги",
        "Предприниматель",
        "Рабтаю по найму",
        "Не работаю не учусь"
    ];

    const handleSkip = () => {
        onNext();
    };

    // Проверяем, заполнены ли обязательные поля (имя и пол)
    const isRequiredFieldsFilled = userData.name && userData.name.trim() !== "" && userData.gender && userData.gender.trim() !== "";

    return (
        <div className="onboarding-page">
            <div className="onboarding-header">
                <h2>Заполнение профиля</h2>
            </div>

            <div className="onboarding-content">
                <div className="form-group">
                    <label>Ваше имя <span className="required">*</span></label>
                    <input
                        type="text"
                        value={userData.name}
                        onChange={(e) => updateUserData('name', e.target.value)}
                        placeholder="Введите ваше имя"
                        className="form-input"
                    />
                </div>

                <div className="form-group">
                    <label>Дата рождения</label>
                    <input
                        type="date"
                        value={userData.birthDate}
                        onChange={(e) => updateUserData('birthDate', e.target.value)}
                        className="form-input"
                    />
                </div>

                <div className="form-group">
                    <label>Ваш пол <span className="required">*</span></label>
                    <div className="dropdown">
                        <div
                            className="dropdown-header"
                            onClick={() => setIsGenderOpen(!isGenderOpen)}
                        >
                            {userData.gender || "Выберите пол"}
                            <ArrowDownIcon className={`arrow-icon ${isGenderOpen ? 'up' : ''}`} />
                        </div>
                        {isGenderOpen && (
                            <ul className="dropdown-list">
                                {genderOptions.map((option) => (
                                    <li
                                        key={option}
                                        onClick={() => {
                                            updateUserData('gender', option);
                                            setIsGenderOpen(false);
                                        }}
                                    >
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label>Род деятельности</label>
                    <div className="dropdown">
                        <div
                            className="dropdown-header"
                            onClick={() => setIsGoalOpen(!isGoalOpen)}
                        >
                            {userData.goal1 || "Выберите род деятельности"}
                            <ArrowDownIcon className={`arrow-icon ${isGoalOpen ? 'up' : ''}`} />
                        </div>
                        {isGoalOpen && (
                            <ul className="dropdown-list">
                                {goalOptions.map((option) => (
                                    <li
                                        key={option}
                                        onClick={() => {
                                            updateUserData('goal1', option);
                                            setIsGoalOpen(false);
                                        }}
                                    >
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            <div className="onboarding-footer">
                <div className="progress-dots">
                    {Array.from({ length: totalSteps }, (_, i) => (
                        <div
                            key={i}
                            className={`progress-dot ${i + 1 === currentStep ? 'active' : ''}`}
                        />
                    ))}
                </div>
                <button className="skip-button" onClick={handleSkip}>
                    Заполнить позже
                </button>
                <button
                    className="next-button"
                    onClick={onNext}
                    disabled={!isRequiredFieldsFilled}
                >
                    Далее
                </button>
            </div>
        </div>
    );
};

export default PersonalInfoPage; 